import {useState} from "react";

export const DownloadOutputData = function ({
  viewOutputUser,
  exportData,
  setIsPopOverOpen
}: {
  viewOutputUser: any;
  exportData: rpExportData | undefined;
  setIsPopOverOpen: any;
}) {
  const [selectedOption, setSelectedOption] = useState("option2");
  const clickYes = () => {
    viewOutputUser(selectedOption);
    // if (selectedOption === "option1") {
    //   if (exportData?.mappedUsers) {
    //     downloadCSV(exportData?.mappedUsers);
    //   }
    // } else if (selectedOption === "option2") {
    //   if (exportData?.unMappedUsers) {
    //     downloadCSV(exportData?.unMappedUsers);
    //   }
    //   //mappedUsers
    // }
  };
  return (
    <>
      <div className="w-full max-w-lg rounded-lg bg-white p-2 shadow-lg">
        <h2 className="mb-4 text-xl font-semibold">View Users</h2>
        <div
          className={`mb-2 flex items-center gap-1 rounded-xl p-1 ${
            selectedOption === "option1"
              ? "border-3 border-yellow-400 bg-yellow-100"
              : ""
          }`}
        >
          <input
            type="radio"
            id="option1"
            name="boardingPoint"
            className="h-3 w-3"
            checked={selectedOption === "option1"}
            onChange={() => setSelectedOption("option1")}
          />
          <div className="flex flex-col gap-1">
            <div className="rounded-lg">Unmapped Users</div>
          </div>
        </div>
        <div
          className={`mb-2 flex items-center gap-1 rounded-xl p-1 ${
            selectedOption === "option2"
              ? "border-3 border-yellow-400 bg-yellow-100"
              : ""
          }`}
        >
          <input
            type="radio"
            id="option1"
            name="boardingPoint"
            className="h-3 w-3"
            checked={selectedOption === "option2"}
            onChange={() => setSelectedOption("option2")}
          />
          <div className="flex flex-col gap-1">
            <div className="rounded-lg"> {"Mapped Users"}</div>
          </div>
        </div>

        <div className="mt-2 flex justify-between gap-4">
          <button
            type="button"
            className="w-full rounded-lg bg-gray-300 px-4 py-2 font-medium text-gray-700"
            onClick={() => setIsPopOverOpen(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="w-full rounded-lg bg-black px-4 py-2 font-medium text-white"
            onClick={() => clickYes()}
            //disabled={neededCreditPoint === 0}
          >
            View
          </button>
        </div>
      </div>
    </>
  );
};
